import http from '@/libs/AxiosPlugin'

const collector = {
  list () {
    return http.get('/collector/list')
    // return new Promise((resolve, reject) => {
    //   let data = [
    //     {id: 1, name: 'xt-01', deviceNo: '443234', type: 'xxx', computeType: 'xxxx', length: 30, count: 12, width: 20, deviceCompany: 'HECCI', deviceModel: 'GE-100', buyTime: '2017-08-20', deviceLifeTime: 20},
    //     {id: 1, name: 'xt-02', deviceNo: '234456', type: 'xxx', computeType: 'xxxx', length: 30, count: 12, width: 20, deviceCompany: 'HECCI', deviceModel: 'GE-100', buyTime: '2017-08-20', deviceLifeTime: 20}
    //   ]
    //   resolve(data)
    // })
  },

  delete (id) {
    return http.post('/collector/delete', {id})
  },

  get (id) {
    return http.post('/collector/get', {id})
  },

  save (c) {
    return http.post('/collector/save', c)
  }
}

export default collector



// WEBPACK FOOTER //
// ./src/api/collector.js